import React, { Component } from "react";
import Button from "../../components/Button";
import Select from "../../components/Select";
import { Input, Checkbox, Textarea, FileInput } from "../../components/Input";
import "./Form.css";
import { validate } from "./Validate.js";
import { submit } from "./Submit.js";
import warningIcon from "../../assets/imgs/warning-icon.svg";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ym from "react-yandex-metrika";
import { loadInformation } from "../../actions/InformationActions";
import { HOST } from "../../constants/Fetch";
import requestAll from "../../actions/Common";
import { bindActionCreators } from "redux";

class FormApplication extends Component {
  static requestData(store) {
    return requestAll([loadInformation], store);
  }
  componentDidMount() {
    this.props.actions.loadInformation();
  }

  state = {
    isValidated: false,
    showFormSuccess: false,
    isShowedAllCities: false,
  };

  toggleAllCities = () => {
    this.setState({ isShowedAllCities: !this.state.isShowedAllCities });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (validate(this.formEl)) {
      if(this.props.internships) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'internship'});
      } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'questionnaire'});
      }
      submit(this.props.history, true, event, this, this.props.apiUrl);
    }
    this.setState({ isValidated: true });
    ym("reachGoal", "send_cv");
  };

  render() {
    const currentCities =
      this.props.vacancy.city && this.props.vacancy.city.length
        ? this.props.vacancy.city.map((el) => el.name)
        : [];

    const cityNames = [];
    if (this.props.cities) {
      for (let i = 0; i < this.props.cities.length; i++) {
        cityNames[i] = {
          label: this.props.cities[i].name,
          value: this.props.cities[i].id,
        };
      }
    }

    return (
      <form
        id="goal103"
        noValidate
        ref={(form) => (this.formEl = form)}
        className={`form ${this.props.modifier ? this.props.modifier : ""} ${
          this.state.isValidated ? "form--wasValidated" : ""
        }`}
        onSubmit={this.handleSubmit}
      >
        {this.props.vacancy && this.props.vacancy.id && (
          <Input
            id="form-intership"
            modifier="input--wide input--hidden"
            label="Вакансия"
            hidden
            value={this.props.vacancy.id}
            name={this.props.internships ? "internship" : "vacancy"}
          />
        )}
        <div className="form__row row row--smallOffset">
          <div className="form__col col colVertTablet--12">
            {currentCities.length > 0 && (
              <div className="form-warning__container">
                <img src={warningIcon} className="form-warning__icon" />
                <div>
                  <span>
                    Обратите внимание: эта вакансия открыта в{" "}
                    {currentCities.length == 1 ? "городе" : "городах"}{" "}
                  </span>
                  {currentCities.length <= 10 ? (
                    currentCities.map((el, i) => {
                      return (
                        <span
                          key={`available-city-${i}`}
                          className="form-warning__city--bold"
                        >
                          &nbsp;{el}
                          {i !== currentCities.length - 1 ? "," : ""}
                          <wbr />
                        </span>
                      );
                    })
                  ) : (
                    <React.Fragment>
                      {currentCities.slice(0, 10).map((el, i) => {
                        return (
                          <span
                            key={`available-city-first-ten-${i}`}
                            className="form-warning__city--bold"
                          >
                            &nbsp;{el}
                            {i !== currentCities.length - 1 ? "," : ""}
                            <wbr />
                          </span>
                        );
                      })}
                      {this.state.isShowedAllCities &&
                        currentCities
                          .slice(10, currentCities.length)
                          .map((el, i) => {
                            // console.log("i:", i, "el:", el, "length:", currentCities.length)
                            return (
                              <span
                                key={`available-city-all-${i}`}
                                className="form-warning__city--bold"
                              >
                                &nbsp;{el}
                                {/* 11 is count of skipping elements in slice */}
                                {i + 11 !== currentCities.length ? "," : ""}
                                <wbr />
                              </span>
                            );
                          })}
                      <button
                        className={`form-show-cities-btn ${this.state
                          .isShowedAllCities &&
                          "form-show-cities-btn--rotated"}`}
                        onClick={this.toggleAllCities}
                        type="button"
                      ></button>
                    </React.Fragment>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="form__row row row--smallOffset">
          <div className="form__col col colVertTablet--12">
            <Input
              id="form-name"
              required
              modifier="input--wide"
              label="Имя"
              name="first_name"
            />
          </div>
          <div className="form__col col colVertTablet--12">
            <Input
              id="form-surname"
              required
              modifier="input--wide"
              label="Фамилия"
              name="last_name"
            />
          </div>
        </div>
        <div className="form__row row row--smallOffset">
          <div className=" form__col col colVertTablet--12">
            <Input
              id="form-phone"
              type="phone"
              required
              modifier="input--wide"
              label="Телефон"
              name="phone"
            />
          </div>
          <div className="form__col col colVertTablet--12">
            <Input
              id="form-mail"
              required
              type="email"
              modifier="input--wide"
              label="Эл. почта"
              name="email"
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            />
          </div>
        </div>
        {this.props.internships && [
          <div className="form__row row row--smallOffset" key="form_age-key">
            <div className="form__col col col--6 colVertTablet--12">
              <Input
                id="form-age"
                required
                modifier="input--wide"
                label="Ваш возраст"
                name="age"
              />
            </div>
          </div>,
          <div className="form__row row row--smallOffset" key="form_text-key">
            <div className="form__col col colVertTablet--12">
              <Textarea
                modifier="input--wide"
                label="Расскажите, пожалуйста, где вы учились или учитесь (вуз, факультет, кафедра, специальность)."
                name="information_study"
              />
            </div>
          </div>,
          <div className="form__row row row--smallOffset" key="form_shcool-key">
            <div className="form__col col col--6 colVertTablet--12">
              <Input
                id="form-school"
                required
                modifier="input--wide"
                label="Год поступления и окончания ВУЗа"
                name="year_study"
              />
            </div>
          </div>,
        ]}
        <div className="form__row row row--smallOffset">
          <div className="form__col col colVertTablet--12">
            <Textarea
              modifier="input--wide"
              label="Расскажите доп. сведения о себе"
              name="information"
            />
          </div>
        </div>
        <div className="form__row row row--smallOffset">
          <div className="form__col col col--6 colVertTablet--12">
            <Input
              id="form-resume"
              modifier="input--wide"
              label="Приложите ссылку на свое резюме"
              name="resume_link"
              type="url"
            />
          </div>
          <div className="form__col col col--6">
            <FileInput
              name="resume_file"
              modifier={
                this.props.modifier &&
                this.props.modifier.indexOf("form--lighten") !== -1 &&
                "input--lighten"
              }
              id="resume_file"
            />
          </div>
        </div>
        <div className="form__col col--6 colVertTablet--12">
          <Select
            name="city"
            required
            options={cityNames}
            placeholder="Мой город"
            alphabeticSort={true}
          />
        </div>
        <div className="form__row form__row--marginTop row row--smallOffset">
          <div className="form__col col colVertTablet--12">
            <Checkbox
              required
              modifier={
                this.props.modifier &&
                this.props.modifier.indexOf("form--lighten") !== -1 &&
                "input--lighten"
              }
              id="apply"
              checked={false}
            >
              Я ознакомлен и согласен с{" "}
              <a
                href={HOST + this.props.information.personal_oferta}
                target="_blank"
              >
                условиями сбора и обработки персональных данных
              </a>
            </Checkbox>
          </div>
        </div>
        <div className="form__receivedMsg"></div>
        <Button
          disabled={this.state.showFormSuccess && true}
          link="/"
          text="Отправить анкету"
          modifier="button--wide-mobile"
          submit
        />
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    information: state.information.item,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadInformation }, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FormApplication)
);



// WEBPACK FOOTER //
// ./src/components/Form/FormApplication.js